import React from "reactn";
import { TextField, InputAdornment, IconButton } from "@material-ui/core";
import { SendOutlined, Close } from "@material-ui/icons";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";

import axios from "axios";

class SendMessage extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      message: "",
      emoji: false
    };
    this.emojiref = React.createRef();
    this.sendMessage = this.sendMessage.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  async sendMessage(e) {
    e.preventDefault();
    if (this.state.message.trim().length > 0) {
      const ep = `${process.env.REACT_APP_API}/partners/connections/simple-sms`;
      this.props.insertMessage(this.state.message);
      await axios.post(ep, {
        toPhone: this.props.phone,
        body: this.state.message
      });
      this.setState({ message: "" });
      // this.props.setRefetch(Math.random());
    }
  }

  handleKeyDown(e) {
    if ((e.key === 'Tab' || e.key === ' ') && this.props.aiSuggestion && !this.state.message) {
      e.preventDefault();
      this.setState({ message: this.props.aiSuggestion });
      if (this.props.onAcceptSuggestion) {
        this.props.onAcceptSuggestion();
      }
    }
  }
  componentDidMount() {
    document.body.addEventListener("click", e => {
      let element = e.target;
      while (element.parentNode) {
        if (element.parentNode.classList)
          if (element.parentNode.classList.contains("emoji-mart")) return;
        element = element.parentNode;
      }
      this.setState({
        emoji: false
      });
    });
  }
  render() {
    return (
      <div
        style={{
          padding: "0 5px",
          position: "absolute",
          bottom: "0px",
          width: "100%"
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
          <button
            onClick={this.props.generateAISuggestion}
            disabled={this.props.isGeneratingSuggestion || !this.props.messageThread?.messages?.length}
            style={{
              backgroundColor: this.props.isGeneratingSuggestion ? '#ccc' : '#4a90e2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              cursor: this.props.isGeneratingSuggestion ? 'not-allowed' : 'pointer',
              fontSize: '12px',
              marginRight: '8px'
            }}
          >
            {this.props.isGeneratingSuggestion ? 'Generating...' : 'Suggest Response'}
          </button>
        </div>
 
        <form>
          <div style={{ position: "relative" }}>
            <TextField
              id="messagetext"
              placeholder={this.props.aiSuggestion ? "Click Tab or Space to accept" : "Type a message..."}
              variant="outlined"
              multiline
              maxRows="4"
              fullWidth
              value={this.state.message}
              onChange={e => {
                this.setState({ message: e.target.value });
                if (e.target.value && this.props.onClearSuggestion) {
                  this.props.onClearSuggestion();
                }
              }}
              onKeyPress={e => {
                if (e.key === "Enter") this.sendMessage(e);
              }}
              onKeyDown={this.handleKeyDown}
              style={{
                border: "1px solid grey",
                borderRadius: "10px",
                marginBottom: "10px",
                display: "block"
              }}
              InputProps={{
                className: this.props.aiSuggestion ? 'ai-suggestion-input' : '',
                style: {
                  backgroundColor: this.props.aiSuggestion ? '#f0f8ff' : 'white',
                  border: this.props.aiSuggestion ? '2px solid #4a90e2' : '1px solid grey'
                },
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <p style={{ marginBottom: 0 }}>
                        <button
                          style={{
                            padding: "12px",
                            backgroundColor: "transparent",
                            border: "none"
                          }}
                          onClick={e => {
                            e.preventDefault();
                            this.setState({
                              emoji: true
                            });
                          }}
                        >
                          😃
                        </button>
                      </p>
                    </InputAdornment>
                    <InputAdornment position="end">
                      <IconButton type="submit" onClick={this.sendMessage}>
                        <SendOutlined />
                      </IconButton>
                    </InputAdornment>
                  </>
                )
              }}
            />
            {this.state.emoji && (
              <Picker
                ref={this.emojiref}
                style={{ position: "absolute", right: 0, top: -370 }}
                onSelect={e => {
                  this.setState({
                    message: this.state.message + e.native,
                    emoji: false
                  });
                  document.getElementById("messagetext").focus();
                }}
                onClick={(e, v) => {}}
              />
            )}
          </div>
        </form>
      </div>
    );
  }
}

export default SendMessage;
